import React from 'react';
import { CheckIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { Pill } from './Pill';
import { heroBadges, heroImage, stats } from '../data/copy';
export function Hero() {
  return <header className="w-full bg-zinc-950" data-id="element-96" data-mp="9k0gndfbepsa">
      <div className="mx-auto max-w-4xl px-6 pb-10 pt-8 text-center sm:pt-10" data-id="element-97" data-mp="9ipbpaa4vbzl">
        <Pill tone="gold" data-id="element-98" data-mp="4n9z0lnv3m4r">Per allenatori di pallavolo</Pill>

        <h1 className="mx-auto mt-4 max-w-3xl font-serif text-[1.75rem] font-bold leading-[1.1] text-stone-100 sm:text-[2.75rem] lg:text-[3.4rem]" data-id="element-99" data-mp="12a0kd8y2xwtk">
          Pianifica il tuo allenamento di pallavolo in{' '}
          <span className="text-yellow-500" data-id="element-100" data-mp="sai3509k0p57">5 minuti</span>
        </h1>

        {/* El mockup va inmediatamente debajo de la promesa (el titular). */}
        <div className="relative mt-7" data-id="element-101" data-mp="neavn31if5l5">
          <div className="absolute inset-x-0 bottom-8 top-10 rounded-3xl bg-zinc-900" aria-hidden="true" data-id="element-102" data-mp="3d21uq4bdkwqw" />
          <img src={heroImage} alt="Pallavolo 360 completo: 6 volumi tecnici, 96 sessioni pronte all'uso e 5 bonus esclusivi." className="relative mx-auto w-full max-w-sm sm:max-w-xl lg:max-w-2xl" width={1240} height={1240} decoding="sync" loading="eager" {...{
          fetchpriority: 'high'
        }} data-id="element-103" data-mp="3825wymt9u1js" />
        </div>

        <p className="mx-auto mt-4 max-w-prose font-sans text-sm leading-relaxed text-stone-400 sm:text-base" data-id="element-104" data-mp="399jppk78yr9a">
          Il sistema digitale visuale per allenatori di pallavolo: tecnica passo
          dopo passo, esercizi illustrati, progressioni, schemi di campo e
          allenamenti già organizzati.
        </p>

        <div className="mt-7" data-id="element-105" data-mp="35a2jupnwrs3l">
          <CtaButton href="#oferta" size="large" className="w-full sm:w-auto" data-id="element-106" data-mp="2qk3kijkmaamj">
            Accesso completo ora
          </CtaButton>
        </div>

        <ul className="mt-6 flex flex-wrap justify-center gap-x-5 gap-y-2" data-id="element-107" data-mp="2vjg6l23nzdo2">
          {heroBadges.map(badge => <li key={badge} className="flex items-center gap-1.5 font-sans text-[11px] text-stone-400 sm:text-xs" data-id="element-108" data-mp="2hjowhcg9qhfc">
              <CheckIcon className="h-3.5 w-3.5 text-yellow-500" strokeWidth={2.6} aria-hidden="true" data-id="element-109" data-mp="2lmv0sejtlyj6" />
              {badge}
            </li>)}
        </ul>
      </div>

      <div className="border-y border-zinc-800 bg-zinc-900" data-id="element-110" data-mp="na9xyj16r4ia">
        <dl className="mx-auto grid max-w-6xl grid-cols-3 divide-x divide-zinc-800 px-6" data-id="element-111" data-mp="ibyrmia3nc4t">
          {stats.map(stat => <div key={stat.label} className="px-3 py-7 text-center" data-id="element-112" data-mp="ddngm482ivl0">
              <dd className="font-serif text-4xl font-bold leading-none text-yellow-500 sm:text-5xl" data-id="element-113" data-mp="dbaoiy8lj4u8">
                {stat.value}
              </dd>
              <dt className="mt-2 font-sans text-[10px] font-semibold uppercase tracking-[0.18em] text-stone-400 sm:text-xs" data-id="element-114" data-mp="162ugb6j9dr7u">
                {stat.label}
              </dt>
            </div>)}
        </dl>
      </div>
    </header>;
}